import {
    useEffect, useId, useRef, useState,
} from 'react';

export const emailsMatch = (email, confirmation) => Boolean(
    email.trim() && email.trim().toLowerCase() === confirmation.trim().toLowerCase(),
);

export default function EmailConfirmation({
    email, value, onChange, label,
}) {
    const fieldId = useId();
    const input = useRef(null);
    const [showError, setShowError] = useState(false);
    const [focused, setFocused] = useState(false);
    const matches = emailsMatch(email, value);
    const mismatch = Boolean(showError && value && !matches);

    useEffect(() => {
        input.current.setCustomValidity(matches ? '' : 'Email addresses must match.');
    }, [matches]);

    useEffect(() => {
        if (!focused || !value || matches) return undefined;
        const timer = setTimeout(() => setShowError(true), 2500);
        return () => clearTimeout(timer);
    }, [focused, value, matches]);

    return (
        <div>
            <label className="po-field" htmlFor={fieldId}>
                <span>{label}</span>
                <input
                    ref={input}
                    id={fieldId}
                    type="email"
                    value={value}
                    onChange={(event) => {
                        setShowError(false);
                        onChange(event.target.value);
                    }}
                    onFocus={() => {
                        setFocused(true);
                        setShowError(false);
                    }}
                    onBlur={() => {
                        setFocused(false);
                        setShowError(true);
                    }}
                    maxLength={254}
                    autoComplete="off"
                    required
                    aria-invalid={mismatch}
                    aria-describedby={mismatch ? `${fieldId}-error` : undefined} />
            </label>
            {mismatch && (
                <p className="po-error" id={`${fieldId}-error`} role="alert">
                    Email addresses must match.
                </p>
            )}
        </div>
    );
}
